import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SubNavigationTopComponent } from '@nk/app/top-menu/sub-navigation/sub-navigation-top.component';
import { CompanyPersonSearchBoxComponent } from '@nk/company-person-search-block';
import { CountryFocusItemsModule } from '@nk/shared/components/country-focus-items/country-focus-items.module';
import { FeedbackModule } from '@nk/shared/components/feedback/feedback.module';
import { PipeUtilsModule } from '@nk/shared/pipes/pipe-utils.module';
import { SharedModule } from '@nk/shared/shared.module';
import { DatatableModule, TabMenuComponent } from '@nk/ui-lib';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AppHeaderNavComponent } from './app-header-nav/app-header-nav.component';
import { SubNavigationBreadcrumbComponent } from './sub-navigation-breadcrumb/sub-navigation-breadcrumb.component';
import { TopSearchInlineMobileComponent } from './top-search-inline-mobile/top-search-inline-mobile.component';
import { TopSearchComponent } from './top-search/top-search.component';
import { UserMenuMobileComponent } from './user-menu-mobile/user-menu-mobile.component';

@NgModule({
  declarations: [
    AppHeaderNavComponent,
    TopSearchComponent,
    UserMenuMobileComponent,
    TopSearchInlineMobileComponent,
    SubNavigationBreadcrumbComponent,
    SubNavigationTopComponent,
  ],
  imports: [
    BsDropdownModule.forRoot(),
    CommonModule,
    TranslateModule,
    CompanyPersonSearchBoxComponent,
    RouterModule,
    SharedModule,
    CollapseModule,
    CountryFocusItemsModule,
    FeedbackModule,
    DatatableModule,
    PipeUtilsModule,
    TabMenuComponent,
  ],
  exports: [AppHeaderNavComponent, TopSearchComponent, UserMenuMobileComponent, SubNavigationTopComponent],
})
export class TopMenuModule {}
